export default __webpack_public_path__ + "static/media/Vector.9b23ba59.svg";